import {
    ActionIcon,
    Box,
    Group,
    NumberFormatter,
    Stack,
    Text,
    Tooltip,
} from '@mantine/core';
import { IconListSearch, IconPlus } from '@tabler/icons-react';

const BalanceCell = ({ cell, openBalanceModal, openBillingModal }) => {
    const { column, row } = cell;
    const rowData = row.original;

    return (
        <Group
            gap={4}
            wrap={false}
            miw={100}>
            <Text>
                <NumberFormatter
                    value={rowData.balance}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    prefix={'$'}
                />
            </Text>
            <Tooltip label={'Top-up user balance'}>
                <ActionIcon
                    color={'teal.6'}
                    variant={'filled'}
                    size={'xs'}
                    onClick={() => openBalanceModal(rowData)}>
                    <IconPlus
                        style={{ width: '70%', height: '70%' }}
                        stroke={1.5}
                    />
                </ActionIcon>
            </Tooltip>

            <Tooltip label={'View user billing'}>
                <ActionIcon
                    color={'blue.5'}
                    variant='filled'
                    size={'xs'}
                    onClick={() => openBillingModal(rowData)}>
                    <IconListSearch
                        style={{ width: '70%', height: '70%' }}
                        stroke={1.5}
                    />
                </ActionIcon>
            </Tooltip>
        </Group>
    );
};

const BalanceColumn = ({ openBalanceModal, openBillingModal }) => ({
    accessorKey: 'balance',
    header: 'Balance',
    size: 1,
    Cell: ({ cell }) => (
        <BalanceCell
            cell={cell}
            openBalanceModal={openBalanceModal}
            openBillingModal={openBillingModal}
        />
    ),
});
export default BalanceColumn;
